<script setup lang="ts">
const props = defineProps<{
  productLineNid: number
  surfaceCollectionNid: number
}>()

const filter = [
  {
    [APIFilterOP.EQUALS]: {
      'productLine.nid': props.productLineNid,
    },
  },
  {
    [APIFilterOP.EQUALS]: {
      'surfaceCollections.nid': props.surfaceCollectionNid,
    },
  },
]

const { data: productsData, status } = await useLazyAsyncData(() =>
  createProductsRepository().getAllProducts({
    filter: APIFilters.makeFilter(filter),
    sort: APIFilters.makeSort({ weight: 'ASC' }),
  })
)

const products = computed(() => productsData.value?.items ?? [])
</script>

<template>
  <div class="-mt-8 pl-4">
    <UiSkeletonDescriptionItems v-if="status === 'pending'" />
    <ul v-else class="list-none p-0">
      <li v-for="product in products" :key="product.nid" class="py-1">
        {{ product.title }}
      </li>
    </ul>
  </div>
</template>

<style scoped></style>
